
import { Component, Vue } from "vue-property-decorator";
import PageFooter from "@/components/page-footer.vue";
	import Switch from '@/components/switch.vue'
  import Dialog from '@/components/dialog.vue';
  import {
    materialGrassShowtaglist,
    materialGrassShowtagsave,
    materialGrassShowtagdelete,
    materialGrassShowlist,
    materialGrassShowpullBlack,
    materialGrassShowrecover,
    materialGrassShowpass,
    materialGrassShowUpdateLikeCount,
    materialGrassShowWhiteListlist,
    materialGrassShowWhiteListdelete,
    materialGrassShowWhiteListsearch,
    materialGrassShowWhiteListsave,
  } from "@/api/material"
	import Message from '@/components/message.vue'
	import PickerDate from '@/components/picker-date.vue';
@Component({
  name: "",
  components: {
    PageFooter,
    'rt-switch':Switch,
    'rt-dialog':Dialog,
    Message,
    PickerDate
  },
})
export default class ProductList extends Vue {
  private activeName = '2'
  private pageNo = 1;
  private pageSize = 10;
  private total = 0;
  private keywords = ''
  private tablelist:any = []
  private tableloading = false

  private labelShow = false
  private rowmsg:any = {
    Id:0,
    Name:'',
    IsOpen:true,
    SortAsc:'',
  }
  private delShow = false

  private lookmsg:any = {}
  private excellentkeywords = ''
  private excellentlabel:any = []
  private excellentlabellist:any = []
  private state = null
  private statelist:any = [
    {value:null,label:'全部'},
    {value:0,label:'待审核'},
    {value:1,label:'已通过'},
    {value:2,label:'已驳回'},
    {value:3,label:'已拉黑'},
  ]
  private excellentlist:any = []
  private excellentloading = false
  private blackShow = false
  private excellentrowmsg:any = {}
  private selectlist:any = []

  private whiteShow = false
  private whiteList:any = []
  private whiteloading = false
  private whitePageSize = 10
  private whitePageNo = 1
  private whiteTotal = 0
  private whiteMsg:any = {}
  private delWhiteShow = false
  private addWhiteShow = false
  private addWhiteKeyowrds = ''
  private addWhiteList:any = []

  private mounted (){
    this.info()
  }
  activated () {
    this.info()
  }


  private delAddWhite(e){
    this.addWhiteList.splice(e,1)
  }
  private async saveWhite(){
    if(!this.addWhiteList||!this.addWhiteList.length){
      this.$message.error('请添加白名单用户')
      return
    }
    try{
      let res:any = await materialGrassShowWhiteListsave({
        MaterialGrassShowWhiteListSaveDtos:this.addWhiteList.map(v=>{
          return {
            MemberId:v.MemberId,
            Name:v.Name
          }
        })
      })
      if(res.IsSuccess){
        this.addWhiteShow = false
        this.whiteChangeCurrent(1)
      }
    }finally{
      //
    }
  }
  private async searchPerson(){
    if(!this.addWhiteKeyowrds){
      this.$message.error('请输入代理手机号')
      return 
    }
    if(this.addWhiteList.find(v=>v.Phone==this.addWhiteKeyowrds)){
      this.$message.error('已在待加入列表，请勿重复添加')
      return 
    }
    try{
      let res:any = await materialGrassShowWhiteListsearch({
        Keywords:this.addWhiteKeyowrds
      })
      if(res.IsSuccess){
        this.addWhiteList.push(res.Result)
      }
    }finally{
      //
    }
  }
  private toAddWhite(){
    this.addWhiteKeyowrds = ''
    this.addWhiteList = []
    this.addWhiteShow = true
  }
  private async confirmDeleteWhite(){
    try{
      let res = await materialGrassShowWhiteListdelete({
        Id:this.whiteMsg.Id
      })
      if(res.IsSuccess){
        this.$message.success('操作成功')
        this.delWhiteShow = false
        this.getwhiteList()
      }
    }finally{
      //
    }
  }
  private delWhite(row){
    this.whiteMsg = row
    this.delWhiteShow = true
  }
  private whiteChangeCurrent(e){
    this.whitePageNo = e
    this.getwhiteList()
  }
  private async getwhiteList(){
    this.whiteloading = true
    try{
      let data:any = {
        Skip:(this.whitePageNo-1)*this.whitePageSize,
        Take:this.whitePageSize
      }
      let res = await materialGrassShowWhiteListlist(data)
      if(res.IsSuccess){
        this.whiteList = res.Result.Results
        this.whiteTotal = res.Result.Total
      }
    }finally{
      this.whiteloading = false
    }
  }
  private async saveChangeLikeCount(){
    if(this.excellentrowmsg.LikeCount<0||this.excellentrowmsg.LikeCount>1000000){
      this.$message.error('喜欢人数允许0~100万的数值')
      return
    }
    try{
      this.tableloading = true
      let res:any = await materialGrassShowUpdateLikeCount({
        Id:this.excellentrowmsg.Id,
        LikeCount:this.excellentrowmsg.LikeCount
      })
      if(res.IsSuccess){
        this.$message.success('操作成功')
        this.getexcellentlist()
      }
    }finally{
      this.tableloading = false
    }
  }
  private toChangeListCount(row){
    this.excellentrowmsg = JSON.parse(JSON.stringify(row))
  }
  private setselectable(row){
    // console.log(row)
    return row.State == 0
  }
  private async batchpass(){
    if(!this.selectlist||!this.selectlist.length){
      this.$message.error('请先选择要操作的对象')
      return
    }
    let num = 0
    try{
      this.excellentloading = true
      // console.log(this.selectlist.map(v=>v.Id))
      // return 
      for(let item of this.selectlist){
        let res = await materialGrassShowpass({
          Id:item.Id
        })
        num++
      }
    }finally{
      this.excellentloading = false
      if(num==this.selectlist.length){
        this.$message.success('操作成功')
        this.getexcellentlist()
        this.$nextTick(()=>{
          (this.$refs.table as any).clearSelection()
        })
      }
    }
  }
  private getkey(row){
    // console.log(row)
    return row.Id
  }
  private selectshop(list){
    this.selectlist = list
  }
  private info(){
    if(this.activeName == '1'){
      this.gettablelist()
    }else if(this.activeName == '2'){
      this.getlooklabellist()
      this.getexcellentlist()
      this.$nextTick(()=>{
        (this.$refs.table as any).clearSelection()
      })
    }
  }


  private tocheck(row,type){
    this.$router.push({
      path:'checkgrassshow',
      query:{
        Id:row.Id,
        type:type
      }
    })
  }
  private async recover(row){
    try{
      let res = await materialGrassShowrecover({
        Id:await row.Id
      })
      if(res.IsSuccess){
        this.$message.success('操作成功')
        this.getexcellentlist()
      }
    }finally{
      //
    }
  }
  private pullblack(row){
    this.excellentrowmsg = row
    this.blackShow = true
  }
  private async confirmblack(){
    try{
      let res = await materialGrassShowpullBlack({
        Id:this.excellentrowmsg.Id
      })
      if(res.IsSuccess){
        this.$message.success('操作成功')
        this.blackShow = false
        this.getexcellentlist()
      }
    }finally{
      //
    }
  }
  private async getexcellentlist(){
    this.excellentloading = true
    try{
      let data:any = {
        Keywords:this.excellentkeywords,
        State:this.state,
        MaterialGrassShowTagIdList:this.excellentlabel,
        Skip:(this.pageNo-1)*this.pageSize,
        Take:this.pageSize
      }
      let res = await materialGrassShowlist(data)
      if(res.IsSuccess){
        this.excellentlist = res.Result.Results.map(v=>{
          v.changeLikeShow = false
          return v
        })
        this.total = res.Result.Total
      }
    }finally{
      this.excellentloading = false
    }
  }
  private async getlooklabellist(){
    try{
      let data:any = {
        Name:'',
        Skip:0,
        Take:999999
      }
      let res = await materialGrassShowtaglist(data)
      if(res.IsSuccess){
        this.excellentlabellist = res.Result.Results
      }
    }finally{
      //
    }
  }
  private lookdetail(row){
    this.activeName = '2'
    this.lookmsg = row
    // console.log(row)
    this.excellentlabel = [row.Id]
    this.getlooklabellist()
    this.getexcellentlist()
  }
  private async confirmDelete(){
    try{
      let res = await materialGrassShowtagdelete(this.rowmsg)
      if(res.IsSuccess){
        this.$message.success('操作成功')
        this.delShow = false
        this.gettablelist()
      }
    }finally{
      //
    }
  }
  private dellabel(row){
    this.rowmsg = row
    this.delShow = true
  }
  private changeswitch(e,row){
    this.rowmsg = JSON.parse(JSON.stringify(row))
    this.rowmsg.IsOpen = e
    this.savelabel()
  }
  private async savelabel(){
    if(!this.rowmsg.Name){
      this.$message.error('请输入标签内容')
      return
    }
    try{
      let data:any = JSON.parse(JSON.stringify(this.rowmsg))
      data.SortAsc = Number(data.SortAsc)||0
      let res = await materialGrassShowtagsave(data)
      if(res.IsSuccess){
        this.$message.success('操作成功')
        this.labelShow = false
        this.gettablelist()
      }
    }finally{
      //
    }
  }
  private changeCurrent(e){
    this.pageNo = e
    this.info()
  }
  private handleClick(e){
    this.activeName = e.name
    this.excellentlabel = []
    this.keywords = ''
    this.excellentkeywords = ''
    this.pageNo = 1
    this.info()
  }
  private doSearch(){
    this.pageNo = 1
    this.info()
  }
  private clearSearch(){
    this.pageNo = 1
    if(this.activeName=='1'){
      this.keywords = ''
    }else if(this.activeName=='2'){
      this.excellentkeywords = ''
      this.excellentlabel = []
      this.state = null
    }
    this.info()
  }
  private editlabel(row){
    if(row.Id){
    // console.log(row)
      for(let key in this.rowmsg){
        // console.log(key)
        this.rowmsg[key] = row[key]
      }
    }else {
      this.rowmsg = {
        Id:0,
        Name:'',
        IsOpen:true,
        SortAsc:'',
      }
    }
    this.rowmsg.Id = row.Id
    this.labelShow = true
  }
  private async gettablelist(){
    this.tableloading = true
    try{
      let data:any = {
        Name:this.keywords,
        Skip:(this.pageNo-1)*this.pageSize,
        Take:this.pageSize
      }
      let res = await materialGrassShowtaglist(data)
      if(res.IsSuccess){
        this.tablelist = res.Result.Results
        this.total = res.Result.Total
      }
    }finally{
      this.tableloading = false
    }
  }
}
